





























































































import { Vue, Component, Prop, Watch }    from 'vue-property-decorator'
import { mapGetters }               from 'vuex'
import { FontAwesomeIcon }          from '@fortawesome/vue-fontawesome'

import { Ability }                  from '@/types/Ability'
import ExaGenericTable from '@exatech-group/generic-table/src/GenericTable.vue'
import  ErrorDisplay                from '@/components/ErrorDisplay.vue'

/**
 * Composant contenant l'ensemble des candidats
*/
@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA']),

        ...mapGetters('definitionBarresAnalysesHypotheses', ['tableauHypotheseTrie', 'loading', 'getError', 'hypothesesEpinglees']),
        ...mapGetters('definitionDesBarres', ['selectedTab'])

    },
    components: {
        ExaGenericTable,
        'font-awesome-icon': FontAwesomeIcon,
        ErrorDisplay
    }
})

export default class AnalysesHypotheses extends Vue
{
    @Prop() concour: any

    Ability                 = Ability
    dataForTab: Array<any>  = []
    showModalEditionCandidat = false
    filtres                 = []
    hypotheseEpinglees      = []
    hypotheses_params       = this.$props.concour && this.$props.concour.hypotheses_params ? this.$props.concour.hypotheses_params : []
    // first search, utilisé pour cacher le bouton export avant premiere recherche
    firstSearch             = true
    // utilisé pour disable le bouton export pdf
    exportingIsWorking      = false
    nb_candidats_divise_par_deux = this.$props.concour && this.$props.concour.candidats_count ? Math.ceil(this.$props.concour.candidats_count / 2) : 0

    genericfields = [
        { key: 'h',                     label: 'Hypothèse',                                                 sortable: false,    class: 'header_width text-center', type: 'text' },
        { key: 'barre1',                label: this.$props.concour.deliberation.barres[0].nom,              sortable: true,     class: 'text-center', type: 'text' },
        { key: 'barre2',                label: this.$props.concour.deliberation.barres[1].nom,              sortable: true,     class: 'text-center', type: 'text' },
        { key: 'recu',                  label: 'Nombre d\'admissibles',                                     sortable: true,     class: 'text-center', type: 'text' },
        { key: 'rejet_barre1',          label: 'Rejets ' + this.$props.concour.deliberation.barres[0].nom,  sortable: true,     class: 'text-center', type: 'text' },
        { key: 'rejet_barre2',          label: 'Rejets ' + this.$props.concour.deliberation.barres[1].nom,  sortable: true,     class: 'text-center', type: 'text' },
        { key: 'rejet_global',           label: 'Rejets total',                                              sortable: true,     class: 'text-center', type: 'text' },
        { key: 'pinned',                label: '',                                                          sortable: false, typeAction: 'edit',  class: '', icon:'pen', disabled: false }

    ]

    buidGenericFields () {
        this.genericfields = []
        this.genericfields.push({ key: 'h', label: 'Hypothèse', sortable: false, class: 'header_width text-center', type: 'text' })
        for(let i = 0; i < this.$props.concour.deliberation.barres.length; i++) {
            this.genericfields.push({ key: 'barre' + (i + 1), label: this.$props.concour.deliberation.barres[i].nom, sortable: true, class: 'text-center', type: 'text' })
        }
        this.genericfields.push({ key: 'recu', label: 'Nombre d\'admissibles', sortable: true, class: 'text-center', type: 'text' })
        for(let j = 0; j < this.$props.concour.deliberation.barres.length; j++) {
            this.genericfields.push({ key: 'rejet_barre' + ( j + 1 ), label: 'Rejets ' + this.$props.concour.deliberation.barres[j].nom, sortable: true, class: 'text-center', type: 'text' })
        }
        this.genericfields.push({ key: 'rejet_global', label: 'Rejets total', sortable: true, class: 'text-center', type: 'text' })
        this.genericfields.push({ key: 'pinned', label: '', sortable: false, typeAction: 'edit',  class: '', icon:'pen', disabled: false })
    }

    /* Les options prennent comme valeur la précédente recherche si elle a eu lieux sinon le nb_candidat divisé / 2, maxBarre */
    options = {
        precision: this.hypotheses_params.precision ? this.hypotheses_params.precision : 1,
        objectif:   this.hypotheses_params.objectif ? this.hypotheses_params.objectif : this.nb_candidats_divise_par_deux,
        marge: this.hypotheses_params.marge ? this.hypotheses_params.marge : 0,
        valMinBarre:[this.hypotheses_params.valMinBarre1 ? this.hypotheses_params.valMinBarre1 : 0, this.hypotheses_params.valMinBarre2 ? this.hypotheses_params.valMinBarre2 : 0],
        valMaxBarre: [this.hypotheses_params.valMaxBarre1 ? this.hypotheses_params.valMaxBarre1 : Math.ceil(this.$props.concour.deliberation.barres[0].maxBarre), this.hypotheses_params.valMaxBarre2 ? this.hypotheses_params.valMaxBarre2 : Math.ceil(this.$props.concour.deliberation.barres[1].maxBarre)],
        maxRejetBarre: [this.hypotheses_params.maxRejetBarre1 ? this.hypotheses_params.maxRejetBarre1 : this.nb_candidats_divise_par_deux, this.hypotheses_params.maxRejetBarre2 ? this.hypotheses_params.maxRejetBarre2 : this.nb_candidats_divise_par_deux],
        maxRejet:  this.hypotheses_params.maxRejet ? this.hypotheses_params.maxRejet : this.nb_candidats_divise_par_deux
    }

    buildOptions () {
        this.options = {
            precision: this.hypotheses_params.precision ? this.hypotheses_params.precision : 1,
            objectif:   this.hypotheses_params.objectif ? this.hypotheses_params.objectif : this.nb_candidats_divise_par_deux,
            marge: this.hypotheses_params.marge ? this.hypotheses_params.marge : 0,
            valMinBarre:[this.hypotheses_params.valMinBarre1 ? this.hypotheses_params.valMinBarre1 : 0, this.hypotheses_params.valMinBarre2 ? this.hypotheses_params.valMinBarre2 : 0],
            valMaxBarre: [this.hypotheses_params.valMaxBarre1 ? this.hypotheses_params.valMaxBarre1 : Math.ceil(this.$props.concour.deliberation.barres[0].maxBarre), this.hypotheses_params.valMaxBarre2 ? this.hypotheses_params.valMaxBarre2 : Math.ceil(this.$props.concour.deliberation.barres[1].maxBarre)],
            maxRejetBarre: [this.hypotheses_params.maxRejetBarre1 ? this.hypotheses_params.maxRejetBarre1 : this.nb_candidats_divise_par_deux, this.hypotheses_params.maxRejetBarre2 ? this.hypotheses_params.maxRejetBarre2 : this.nb_candidats_divise_par_deux],
            maxRejet:  this.hypotheses_params.maxRejet ? this.hypotheses_params.maxRejet : this.nb_candidats_divise_par_deux
        }
    }

    @Watch('tableauHypotheseTrie')
    watchTableau() {
        this.setDataForGenericTab(this.$store.getters['definitionBarresAnalysesHypotheses/tableauHypotheseTrie'])
    }

    @Watch('hypothesesEpinglees')
    watchEpingle() {
        if (this.$store.getters['definitionDesBarres/selectedTab'] === 'analysesHypotheses') {
            this.hypotheseEpinglees = this.$store.getters['definitionBarresAnalysesHypotheses/hypothesesEpinglees']
            this.setDataForGenericTab(this.$store.getters['definitionBarresAnalysesHypotheses/tableauHypotheseTrie'])
        }
    }

    @Watch('selectedTab', { immediate: true })
    watchSelectedTab() {
        if (this.$store.getters['definitionDesBarres/selectedTab'] === 'analysesHypotheses') {
            const params = {
                concour_phase : this.$props.concour.id
            }
            this.$store.dispatch('definitionBarresAnalysesHypotheses/getHypothesesEpinglees', params)
        }
        this.setDataForGenericTab(this.$store.getters['definitionBarresAnalysesHypotheses/tableauHypotheseTrie'])
    }

    /**
     * Formatage des datas pour l'affichage dans le tableau générique
     */
    setDataForGenericTab(poData: any, isLoadMore = false)
    {
        if (!isLoadMore)
        {
            this.dataForTab = []
        }
        if (this.hypotheseEpinglees.length > 0) {
            poData = this.hypotheseEpinglees.concat(poData)
        }
        if (poData)
        {
            let counter = 1
            for (const result of poData)
            {
                const barre1        = result.datas.barre1 ? result.datas.barre1 : '-'
                const barre2        = result.datas.barre2 ? result.datas.barre2 : '-'
                const recu          = result.datas.recu ? result.datas.recu : '-'
                const rejet_barre1  = result.datas.rejet_barre1 ? result.datas.rejet_barre1 : '-'
                const rejet_barre2  = result.datas.rejet_barre2 ? result.datas.rejet_barre2 : '-'
                const rejet_global  = result.datas.rejet_global ? result.datas.rejet_global : '-'

                const line: any = [
                    { label: 'Hypothèse', item: result.id ? counter : '', type: 'text', typeAction: null, class: result.id ? 'pinned_color text-center' : 'text-center' },
                    { label: this.$props.concour.deliberation.barres[0].nom, item: barre1, type: 'text',  typeAction: null, class: result.id ? 'pinned_color text-center' : 'text-center' },
                    { label: this.$props.concour.deliberation.barres[1].nom, item: barre2, type: 'text', typeAction: null, class: result.id ? 'pinned_color text-center' : 'text-center' },
                    { label: 'Recu', item: recu, type: 'text',    typeAction: null, class: result.id ? 'pinned_color text-center' : 'text-center' },
                    { label: '', item: rejet_barre1, type: 'text', typeAction: null, class: result.id ? 'pinned_color text-center' : 'text-center' },
                    { label: '', item: rejet_barre2, type: 'text', typeAction: null, class: result.id ? 'pinned_color text-center' : 'text-center' },
                    { label: '', item: rejet_global, type: 'text', typeAction: null, class: result.id ? 'pinned_color text-center' : 'text-center' }
                ]

                /* Logique afin de supprimer l icone de pin si deja pinned, les resultats n'ont pas d id */
                let pinned = {}
                if (this.hypotheseEpinglees.findIndex((pinned: any) => pinned.datas.barre1 === result.datas.barre1 && pinned.datas.barre2 === result.datas.barre2) === -1 || result.id)
                {
                    pinned = { label: 'pinned', item: result, type: 'action', typeAction: 'pinned', class: result.id ? 'commons_comment_button pinned_color' : 'commons_comment_button not_pinned_color', icon:'thumbtack', disabled: false }
                } else {
                    pinned = { label: 'pinned', item: '', type: 'text',  typeAction: null, class: result.id ? 'commons_comment_button pinned_color' : 'commons_comment_button not_pinned_color', icon:'thumbtack', disabled: false }
                }
                line.push(pinned)
                counter += 1
                
                /*
                const line = []
                line.push({ label: 'Hypothèse', item: result.id ? counter : '', type: 'text', typeAction: null, class: result.id ? 'pinned_color text-center' : 'text-center' })
                for (let i = 0; i < this.$props.concour.deliberation.barres.length; i++) {
                    line.push({ label: this.$props.concour.deliberation.barres[i].nom, item: barre1, type: 'text',  typeAction: null, class: result.id ? 'pinned_color text-center' : 'text-center' })
                }
                */

                








                this.dataForTab.push(line)
            }
        }
    }


    /**
     * Formatage des datas pour l'affichage dans le tableau générique
     */
    setFiltersForGenericTab()
    {
        console.log('filtre')
    }

    /**
     * Récupération des events du tableau
     * params[0] => l'action
     * params[1] => l'id de l'item
     */
    handleTableEvent (paParams: any): void
    {
        if (paParams && paParams[0] && paParams[1])
        {
            switch (paParams[0])
            {
                case 'sortHandler':
                    this.filtreSortHandler(paParams[1])
                    break
                case 'pinned':
                    this.pinned(paParams[1])
                    break
                default:
                    break
            }
        }
    }

    /** Ajoute ou surpprime une épingle : si pas d'id, la valeur n'est pas pinned  */
    pinned(params: any) {
        const payload = {
            concours_phase : this.$props.concour.id,
            params: params
        }
        if (params.id === null) {
            this.$store.dispatch('definitionBarresAnalysesHypotheses/postHypothesesEpinglees', payload)
        } else {
            this.$store.dispatch('definitionBarresAnalysesHypotheses/deleteHypothesesEpinglees', payload)
        }
    }

    /**
     * Filtre fait par le front, recup de la direction et compare via un sort.
     */
    filtreSortHandler (params: any)
    {
        const tableauATrier = this.$store.getters['definitionBarresAnalysesHypotheses/tableauHypotheseTrie']
        if (params.direction === 'asc') {
            tableauATrier.sort(function compare(a: any, b: any) {
                if (a.datas[params.sort] < b.datas[params.sort])
                { return -1 }
                if (a.datas[params.sort] > b.datas[params.sort])
                { return 1 }
                return 0
            })
        }
        if (params.direction === 'desc') {
            tableauATrier.sort(function compare(a: any, b: any) {
                if (a.datas[params.sort] > b.datas[params.sort])
                { return -1 }
                if (a.datas[params.sort] < b.datas[params.sort])
                { return 1 }
                return 0
            })
        }
        this.setDataForGenericTab(tableauATrier)
    }

    initDatas (poCandidats: any)
    {
        this.buidGenericFields()
        if (poCandidats)
        {
            this.setDataForGenericTab(poCandidats)
        } else {
            this.$store.dispatch('definitionBarresAnalysesHypotheses/getTableauHypothese').then(() => {
                this.setDataForGenericTab(poCandidats.data.data)
            })
        }
    }

    lancerRecherche() {
        const params = {
            options: {
                precision: Number(this.options.precision),
                objectif: Number(this.options.objectif),
                marge: Number(this.options.marge),
                valMinBarre1: Number(this.options.valMinBarre[0]),
                valMaxBarre1: Number(this.options.valMaxBarre[0]),
                maxRejetBarre1: Number(this.options.maxRejetBarre[0]),
                valMinBarre2: Number(this.options.valMinBarre[1]),
                valMaxBarre2: Number(this.options.valMaxBarre[1]),
                maxRejetBarre2:  Number(this.options.maxRejetBarre[1]),
                maxRejet:  Number(this.options.maxRejet)
            },
            concours_phase : this.$props.concour.id
        }

        this.$store.dispatch('definitionBarresAnalysesHypotheses/getTableauHypothese', params).then(() => {
            this.firstSearch = false
        })
    }

    // exportation des tableaux de valeurs
    exporterAnalysesHypotheses() {
        const payload = {
            concourPhase : this.concour.id
        }
        this.exportingIsWorking = true
        const date: Date = new Date()
        let fileName = 'export_analyses_hypotheses_' + date.getFullYear() + ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1) + (date.getDate())
        fileName += '.xlsx'

        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Exportation en cours de création ...', infosToaster)

        this.$store.dispatch('definitionBarresAnalysesHypotheses/exportTableauHypothese', payload).then((response) => {
            const url = URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'Download',
                fileName
            )
            document.body.appendChild(link)
            link.click()
            this.exportingIsWorking = false
            this.$bvToast.hide(idInfo)
        }).catch((error) => {
            this.exportingIsWorking = false
            this.$bvToast.hide(idInfo)
            console.log('ko: ', error)
        })
    }

    /* Vérifie les champs et contrôle qu'ils soient cohérents. min < max, borne maximum <= note_max */
    verifDesChamps() {
        const infoChamps = { disabled: false, error: '' }
        const userInput = this.options
        const barres = this.$props.concour.deliberation.barres
        const max_barre1 = Math.ceil(this.$props.concour.deliberation.barres[0].maxBarre)
        const max_barre2 = Math.ceil(this.$props.concour.deliberation.barres[1].maxBarre)
        if (userInput && barres && max_barre1 && max_barre2 && userInput.valMaxBarre[1] <= max_barre2) {
            infoChamps.disabled = false
        }
        // controle valeur min barre 0
        if (userInput.valMinBarre[0] >= max_barre1) {
            infoChamps.disabled = true
            infoChamps.error = 'La valeur de la borne minimum de la barre ' + this.$props.concour.deliberation.barres[0].nom + ' doit être inférieure à ' + (max_barre1 - 1) + '.'
        }
        // controle valeur min barre 1
        if (userInput.valMinBarre[1] >= max_barre2) {
            infoChamps.disabled = true
            infoChamps.error = 'La valeur de la borne minimum de la barre ' + this.$props.concour.deliberation.barres[1].nom + ' doit être inférieure à ' + (max_barre2 - 1) + '.'
        }
        // controle valeur max barre 0
        if (userInput.valMaxBarre[0] > max_barre1) {
            infoChamps.disabled = true
            infoChamps.error = 'La valeur de la borne maximum de la barre ' + this.$props.concour.deliberation.barres[0].nom + ' doit être inférieure à ' + (max_barre1) + '.'
        }
        // controle valeur max barre 1
        if (userInput.valMaxBarre[1] > max_barre2) {
            infoChamps.disabled = true
            infoChamps.error = 'La valeur de la borne maximum de la barre ' + this.$props.concour.deliberation.barres[1].nom + ' doit être inférieure à ' + (max_barre2) + '.'
        }
        return infoChamps
    }
}
